import React, { useContext, useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import {
  Col,
  Container,
  Row,
  InputGroup,
  Form,
  Button,
} from "react-bootstrap";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import "./styles.css";
import Context from "../../context/Context";
import { useNavigate } from "react-router-dom";
import { IndustryPartsCards } from "../../componentes/molecules/IndustryPartsTableCards";

export const PartsInDevelopment = () => {
  const { setCode, getFicha, setIndustryPartsTable } = useContext(Context);
  const navigate = useNavigate();

  const [partsInDevelopment, setPartsInDevelopment] = useState([]);
  const [searchPieces, setSearchPices] = useState("");

  const [filters, setFilters] = useState({
    hp: "",
    Dia_Programada: "",
    reviewDate: "",
    ordem_DtLiberacao: "",
    ordem_Nro_Lote: "",
    lote_Corte: "",
    setor_Concatenado: "",
    ordem_Serial: "",
    ordem_Part_Short: "",
    ordem_VehCod: "",
    ordem_VehDesc: "",
    subProduto_Desc: "",
    ordem_CodMaterial: "",
    pedido_Cliente: "",
    orderID: "",
    pedido_Codigo: "",
    pedido_Posicao: "",
    pedido_Data: "",
  });

  const filterLabels = {
    hp: "HP",
    Dia_Programada: "Dia Programada",
    reviewDate: "Dias Produção",
    ordem_DtLiberacao: "Dias Liberação",
    ordem_Nro_Lote: "Lote",
    lote_Corte: "Lote Corte",
    setor_Concatenado: "Setor",
    ordem_Serial: "OP",
    ordem_Part_Short: "Peça",
    ordem_VehCod: "Cod Veículo",
    ordem_VehDesc: "Veículo",
    subProduto_Desc: "Produto",
    ordem_CodMaterial: "Material",
    pedido_Cliente: "Cliente",
    orderID: "Pedido Genisis",
    pedido_Codigo: "Código",
    pedido_Posicao: "Posição",
    pedido_Data: "Data",
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split(".");
    return new Date(`${year}-${month}-${day}`);
  };

  const diasDesdeLiberacao = (data) => {
    if (!data) return "";
    const currentDate = new Date();
    const targetDate = new Date(data);
    const diffTime = currentDate - targetDate;
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  };

  const diasProgramadas = (Data_Lote, Data_Sap) => {


    if (!Data_Lote && !Data_Sap) {
      return " "
    }

    const currentDate = Data_Lote ? new Date(Data_Lote) : new Date();
    const targetDate = Data_Sap ? new Date(Data_Sap) : new Date();



    currentDate.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);
    const diffTime = Math.abs(targetDate.getTime() - currentDate.getTime());
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays > 31 ? "+31" : diffDays;
  };


  const backGroundHours = (dataCompromisso) => {
    if (!dataCompromisso) return "#8bf9a3";
    let parsedDate = dataCompromisso;
    if (typeof dataCompromisso === "string" && dataCompromisso.includes(".")) {
      const [day, month, year] = dataCompromisso.split(".");
      parsedDate = `${year}-${month}-${day}`;
    }
    const currentDate = new Date();
    const targetDate = new Date(parsedDate);
    if (isNaN(targetDate)) return "#8bf9a3";
    const diffTime = targetDate - currentDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays <= 7) return "#FF0000";
    if (diffDays <= 10) return "#FFFF00";
    return "#8bf9a3";
  };

  const handleFilterChange = (e, column) => {
    setFilters({ ...filters, [column]: e.target.value });
  };

  const uniqueValues = (column) => {
    if (column === "reviewDate") {
      const values = partsInDevelopment
        .map((item) => diasDesdeLiberacao(item.reviewDate))
        .filter((v) => v !== "" && v != null);
      return [...new Set(values)];
    }

    if (column === "Dia_Programada") {
      const values = partsInDevelopment
        .map((item) => diasProgramadas(item.reviewDate, item.ordem_DtLiberacao))
        .filter((v) => v !== "" && v != null);
      return [...new Set(values)];
    }
    const values = partsInDevelopment.map((item) => item[column]).filter(Boolean);
    return [...new Set(values)];
  };

  console.log(partsInDevelopment);
  

  const filteredParts = partsInDevelopment
    .filter((item) => {
      if(item.setor_Concatenado === '20APROVADO-INSPFIN') {
        return false;
      }

      const dropdownMatch = Object.keys(filters).every((key) => {
        if (!filters[key]) return true;
        if (key === "reviewDate") {
          const dias = diasDesdeLiberacao(item.reviewDate);
          return dias.toString() === filters[key];
        } else if (key === "Dia_Programada") {
          const dias = diasProgramadas(item.reviewDate, item.ordem_DtLiberacao);
          return dias.toString() === filters[key];
        }
        return item[key]?.toString() === filters[key];
      });

      const search = searchPieces.toLowerCase();
      const searchMatch =
        !searchPieces ||
        item.hp?.toString().toLowerCase().includes(search) ||
        item.lote_Corte?.toString().toLowerCase().includes(search) ||
        item.setor_Concatenado?.toLowerCase().includes(search) ||
        item.ordem_Serial?.toString().toLowerCase().includes(search) ||
        item.ordem_Part_Short?.toLowerCase().includes(search) ||
        item.ordem_VehDesc?.toLowerCase().includes(search) ||
        item.subProduto_Desc?.toLowerCase().includes(search) ||
        item.ordem_CodMaterial?.toLowerCase().includes(search) ||
        item.pedido_Cliente?.toLowerCase().includes(search) ||
        item.pedido_Codigo?.toString().toLowerCase().includes(search) ||
        item.pedido_Posicao?.toString().toLowerCase().includes(search) ||
        item.pedido_Data?.toLowerCase().includes(search);

      return dropdownMatch && searchMatch;
    })
    .sort((a, b) => parseDate(a.pedido_Data) - parseDate(b.pedido_Data));

  useEffect(() => {
    GetPartsInDevelopment();
  }, []);

  const GetPartsInDevelopment = async () => {
    try {
      const { data } = await blogFetch.get("/SAGAViewPecasSetor/pecaDev");
      setPartsInDevelopment(data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleclick = async (item) => {
    setIndustryPartsTable(true);
    const data = await getFicha(item);
    setCode(data);
    navigate("/Dashboard");
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <Container fluid className="app_body">
        <Row>
          <Col>
            <div className="d-flex pb-3 align-items-center justify-content-between">
              <div className="w-20">
                <InputGroup>
                  <Form.Control
                    placeholder="Buscar Peça - Ordem Serial"
                    value={searchPieces}
                    onChange={({ target }) => setSearchPices(target.value)}
                  />
                  <Button variant="primary">Buscar</Button>
                </InputGroup>
              </div>
              <h2 className="title_tables">PEÇAS EM DESENVOLVIMENTO</h2>
              <div>
                <IndustryPartsCards parts={partsInDevelopment} />
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle text-center shadow-sm">
                <thead>
                  <tr>
                    {Object.keys(filters).map((col) => (
                      <th key={col}>
                        <Form.Select
                          size="sm"
                          className="form-select"
                          value={filters[col]}
                          onChange={(e) => handleFilterChange(e, col)}
                        >
                          <option value="">{filterLabels[col]}</option>
                          {uniqueValues(col).map((val) => (
                            <option key={val} value={val}>
                              {val}
                            </option>
                          ))}
                        </Form.Select>
                      </th>
                    ))}
                  </tr>
                  <tr>
                    {Object.values(filterLabels).map((label, idx) => (
                      <th key={idx}>{label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredParts.map((item, idx) => (
                    <tr key={idx}>
                      <td
                        style={{
                          backgroundColor: item.cor_HP,
                          color: item.cor_HP === "#000" ? "#FFFFFF" : "#000000",
                        }}
                      >
                        {item.hp || 0}
                      </td>
                      <td>
                        {diasProgramadas(item.reviewDate, item.ordem_DtLiberacao)}
                      </td>
                      <td>{diasDesdeLiberacao(item.reviewDate)}</td>
                      <td>{diasDesdeLiberacao(item.ordem_DtLiberacao)}</td>
                      <td>{item.ordem_Nro_Lote}</td>
                      <td>{item.lote_Corte}</td>
                      <td>{item.setor_Concatenado}</td>
                      <td
                        className="text-primary fw-bold"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleclick(item.ordem_Serial)}
                      >
                        {item.ordem_Serial}
                      </td>
                      <td>{item.ordem_Part_Short}</td>
                      <td>{item.ordem_VehCod}</td>
                      <td>{item.ordem_VehDesc}</td>
                      <td>{item.subProduto_Desc}</td>
                      <td>{item.ordem_CodMaterial}</td>
                      <td>{item.pedido_Cliente}</td>
                      <td>{item.orderID}</td>
                      <td>{item.pedido_Codigo}</td>
                      <td>{item.pedido_Posicao}</td>
                      <td
                        style={{
                          backgroundColor: backGroundHours(item.pedido_Data),
                        }}
                      >
                        {item.pedido_Data}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
